// extracted by mini-css-extract-plugin
export default {"wrap":"OrderTotal_wrap__mp2NP","item":"OrderTotal_item__J0cuj","name":"OrderTotal_name__WcNbM","value":"OrderTotal_value__D9BP8"};